// Events
export const CHECKIN_EVENT = "checkin_register";
export const RESTAURANT_MENU_VIEW_EVENT = "restaurant_menu_view";
export const RESTAURANT_CAMPAIGN_VIEW_EVENT = "restaurant_campaign_view";

// Event Type
const eventTypes = [
  CHECKIN_EVENT,
  RESTAURANT_MENU_VIEW_EVENT,
  RESTAURANT_CAMPAIGN_VIEW_EVENT,
] as const;
export type FirebaseEventType = typeof eventTypes[number];

// Event Data Type

// CheckIn Events
export interface CHECKIN_EVENT_DETAILS {
  merchant: string;
  userId: string;
}

// Menu Events
export interface RESTAURANT_MENU_VIEW_EVENT_DETAILS {
  merchant: string;
}

// Campaign Events
export interface RESTAURANT_CAMPAIGN_VIEW_EVENT_DETAILS {
  merchant: string;
  campaignId: string;
}

export type FirebaseEventDetailsType =
  | RESTAURANT_MENU_VIEW_EVENT_DETAILS
  | CHECKIN_EVENT_DETAILS
  | null;
